import axios from '@/utilities/api/axios';

export const state = initialState();

export const actions = {
  verifyUser: async (_, payload) => {
    try {
      const res = await axios.post(
        `/member-ofs/verify`,
        payload
      );

      return res;
    } catch (err) {
      console.error(err);
      return;
    }
  },

  inviteExsistingUser: async (_, payload) => {
    try {
      const res = await axios.post(
        `/member-ofs/create-for-existing-user`,
        payload
      );

      return res;
    } catch (err) {
      console.error(err);
      return;
    }
  },

  inviteNewUser: async (_, payload) => {
    try {
      const res = await axios.post(
        `/member-ofs/create-for-new-user`,
        payload
      );

      return res;
    } catch (err) {
      console.error(err);
      return;
    }
  },

  getInviteesInformation: async ({ commit }, payload) => {
    try {
      const { token } = payload;

      const res = await axios.get(`/member-ofs/${token}`);

      commit('mutateInviteesInformation', res.data);

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  updateInviteStatus: async (_, payload) => {
    try {
      const { token, status, ...params } = payload;

      const res = await axios.get(
        `/member-ofs/${token}/${status}`,
        {
          params: { ...params }
        }
      );

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  updateMemberOfRoleAndPermission: async (_, payload) => {
    try {
      const { memberOfId, ...body } = payload;

      const res = await axios.put(
        `/member-ofs/${memberOfId}`,
        body
      );

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  deleteMemberOfFromProject: async (_, payload) => {
    try {
      const { memberOfId } = payload;

      const res = await axios.delete(
        `/member-ofs/${memberOfId}`
      );

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  selfRegistrationExsistingUser: async (_, payload) => {
    try {
      const res = await axios.post(
        `/member-ofs/self/create-for-existing-user`,
        payload
      );

      return res;
    } catch (err) {
      console.error(err);
      return;
    }
  },

  selfRegistrationNewUser: async (_, payload) => {
    try {
      const res = await axios.post(
        `/member-ofs/self/create-for-new-user`,
        payload
      );

      return res;
    } catch (err) {
      console.error(err);
      return;
    }
  },

  newRoleRequest: async (_, payload) => {
    const { memberOfId, ...body } = payload;

    try {
      const res = await axios.post(
        `/member-ofs/${memberOfId}/role-request`,
        body
      );

      return res;
    } catch (err) {
      console.error(err);
      return;
    }
  }
};

export const mutations = {
  mutateInviteesInformation: (state, payload) => {
    state.inviteeInformation = payload;
  }
};

export const getters = {};

function initialState() {
  return {
    inviteeInformation: {}
  };
}
